import SEAT_CHARACTERISTICS from '../../scripts/constants/seat-characteristics-enum';
import SEAT_UPGRADE_TYPES from '../../scripts/constants/seat-upgrade-types';

import CurrencyValueUIModel from './currency-value';
import FareUpsellUIModel from './fare-upsell';

class SeatChoiceFareUpgradeUIModel {
  constructor({
    code,
    currency,
    farelogixDesignator,
    farelogixPrice,
    seatCharacteristics,
    upsell,
  }) {
    /**
     * NOTE: Fare upgrades (FareUpsell objects in SeatChoiceFareUpgrade) must
     * send the fare difference and not the full fare for the cabin upgrade.
     * per http://amv2test.herokuapp.com/api#booking-flow-seat-maps
     */
    this.code = code;
    // this.currency is a representation of the CurrencyValueUIModel from
    // this.upsell.legFare.currency
    this.currency = new CurrencyValueUIModel(currency);
    this.farelogixDesignator = farelogixDesignator;
    this.farelogixPrice = farelogixPrice;
    this.isAisleSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.A) > -1;
    this.isExitRowSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.EXIT_ROW) > -1;
    this.isMiddleSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.M) > -1;
    this.isNonRecliningSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.DO_NOT_RECLINE) > -1;
    this.isWindowSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.W) > -1;
    this.seatCharacteristics = seatCharacteristics || [];
    this.seatUpgradeType = SEAT_UPGRADE_TYPES.FIRST_UPGRADE;
    this.upsell = new FareUpsellUIModel(upsell);
  }

  getSeatLabel() {
    const {
      isAisleSeat,
      isMiddleSeat,
      isWindowSeat,
    } = this;

    let labelCopyID = '';

    if (isWindowSeat) {
      labelCopyID = 'CLASE_PREMIER_WINDOW_SEAT';
    } else if (isAisleSeat) {
      labelCopyID = 'CLASE_PREMIER_AISLE_SEAT';
    } else if (isMiddleSeat) {
      labelCopyID = 'CLASE_PREMIER_MIDDLE_SEAT';
    } else {
      labelCopyID = 'CLASE_PREMIER_SEAT';
    }

    return labelCopyID;
  }

  getSeatLabelSeatMap() {
    const {
      isAisleSeat,
      isWindowSeat,
      isMiddleSeat,
    } = this;

    let labelCopyID = '';

    if (isWindowSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_WINDOW';
    } else if (isAisleSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_AISLE';
    } else if (isMiddleSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_MIDDLE';
    }
    return labelCopyID;
  }

  getUpgradeCurrency() {
    return this.upsell.legFare.currencyCode;
  }

  getUpgradeTotal() {
    return this.upsell.legFare.currencyTotal;
  }
}

export default SeatChoiceFareUpgradeUIModel;
